import { Message } from '@weezevent/nacre';
import { useTranslation } from 'react-i18next';
import React from 'react';

function QuotasExceeded() {
    const { t } = useTranslation();
    return <Message title={t('attendees.invitations.premium_quota_exceeded')} type="danger" visible />;
}

export default QuotasExceeded;
